import { Component, Input, OnInit } from '@angular/core';
import { ModalService } from '@services/helpers/modal/modal.service';
import { IconsDefinitionHelper } from '@shared/common/definition-helper';
import { LoaderSmallComponent } from '../loaders/loader-small/loader-small.component';
import { IconComponent } from '../icon/icon.component';


@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    standalone: true,
    imports: [IconComponent, LoaderSmallComponent]
})
export class ModalComponent extends IconsDefinitionHelper implements OnInit {
  @Input() modalInnerClasses: string = null;
  @Input() modalBodyClasses: string = null;
  @Input() modalHeaderClasses: string = null;
  @Input() removeBodyPadding = false;
  loadingValue = false;

  @Input() set loading(content: boolean) {
    this.loadingValue = content;
  }

  @Input() closeable = true;

  maxWidthValue = '500px';
  maxHeightValue = '50vh';

  @Input() set maxWidth(c) {
    this.maxWidthValue = c;
  }

  @Input() set maxHeight(c) {
    this.maxHeightValue = c;
  }

  @Input() height = '100%';
  @Input() width = '100%';

  /** controls CSS class that triggers our transition */
  isOpen = false;
  isClosing = false;

  constructor(private modalService: ModalService) {
    super();
  }

  ngOnInit(): void {
    setTimeout(() => this.isOpen = true);
  }

  close(): void {
    // trigger the closing animation
    this.isClosing = true;
    this.isOpen = false;
    // wait for animation to finish, then actually tear down and reset state
    setTimeout(() => {
      this.modalService.close();
      this.isClosing = false;
    }, 320);
  }

  onOverlayClick(event: MouseEvent): void {
    if (!this.closeable) return;
    if (event.target !== event.currentTarget) return;
    this.close();
  }
}
